module.exports = __webpack_public_path__ + "img/bg-widget-send-feedback.997aadba.svg";